import React, { useContext, useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Link, useLocation } from 'react-router-dom'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import { ALL_ON, ALL_OFF, getConsent, setConsent, onOpenRequest } from '../../lib/consent'
import useEntryMotion from '../motion/useEntryMotion'
import CookiePreferences from '../CookiePreferences/CookiePreferences'
import './CookieBanner.scss'

/**
 * Three honest choices, none buried: accept all, essential only, or manage
 * per category. Shown until a choice is made, and again whenever a "Cookie
 * settings" link asks for it (then straight in the manage view). On the
 * policy page itself the manager is inline, so the banner stays out of
 * the way there.
 */
const CookieBanner = () => {
  const { translations: t } = useContext(LanguageContext)
  const { pathname } = useLocation()
  const [open, setOpen] = useState(() => getConsent() === null)
  const [manage, setManage] = useState(false)
  const animateIn = useEntryMotion()

  useEffect(
    () =>
      onOpenRequest(() => {
        setManage(true)
        setOpen(true)
      }),
    []
  )

  const choose = (value) => {
    setConsent(value)
    setOpen(false)
    setManage(false)
  }

  const show = open && pathname !== '/privacy'

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={`ck ${manage ? 'ck-manage' : ''}`}
          role='dialog'
          aria-labelledby='ck-title'
          aria-describedby='ck-text'
          initial={animateIn ? { opacity: 0, y: 24 } : false}
          animate={{ opacity: 1, y: 0 }}
          exit={animateIn ? { opacity: 0, y: 24 } : undefined}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        >
          <p id='ck-title' className='ck-title'>{manage ? t.ckManageTitle : t.ckTitle}</p>
          <p id='ck-text' className='ck-text'>
            {manage ? t.ckManageText : t.ckText} <Link to='/privacy' className='ck-link'>{t.ckLink}</Link>
          </p>

          {manage ? (
            <CookiePreferences compact onSaved={() => { setOpen(false); setManage(false) }} />
          ) : (
            <div className='ck-actions'>
              <button type='button' className='ck-btn' onClick={() => choose({ ...ALL_ON })}>{t.ckAccept}</button>
              <button type='button' className='ck-btn ck-btn-ghost' onClick={() => choose({ ...ALL_OFF })}>{t.ckEssential}</button>
              <button type='button' className='ck-manage-link' onClick={() => setManage(true)}>{t.ckManage}</button>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CookieBanner
